module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrThin.f5ff1e4.woff";